// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3N3cp","unreadBadge":"styles_unreadBadge__1-wkO","modalContent":"styles_modalContent__2iHxu","modal":"styles_modal__2_7G4"};